const actionTypes = require('constants/actionTypes');

const setFocusForm = fields => {
    const data = {};
    data[fields] = true;

    const action = {
        type: actionTypes.SET_FOCUS,
        data,
    };

    return action;
};

const selectFalseFocus = field => {
    const action = {
        type: actionTypes.SET_FOCUS,
        data: {},
    };
    action.data[field] = false;

    return action;
};

const triggerValidations = trigger => {
    const action = {
        type: actionTypes.TRIGGER_VALIDATION,
        data: trigger,
    };

    return action;
};

export default {
    setFocusForm,
    selectFalseFocus,
    triggerValidations,
};
